/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import routerLoader from '../i18n/router';
import { HostProvider } from './HostProvider';
import { StorageHelper } from './StorageHelper';

export class LocationHelper {
  static addMocksParams = (params: any, path: string) => {
    let finalPath = path;
    if (params.useMocks && params.useMocks === 'true') {
      finalPath = path.includes('?')
        ? path.concat('&useMocks=true')
        : path.concat('?useMocks=true');
    }
    return finalPath;
  };

  static isControPageVacioIndex = () => {
    return (
      window.location.pathname === '/vacio.html' ||
      window.location.pathname === '/test.html'
    );
  };

  static goToBackendForLoginAndRedirect = (lang: string) => {
    const newUrl = window.location.pathname.split('/');
    if (!window.location.href.includes('not-found')) {
      const backUrl = routerLoader.getBackMapping(
        routerLoader.LoadRouterByPath(newUrl[2], 'es').replace('/es/', ''),
      );
      window.location.href = `${HostProvider.getHost()}${
        lang || 'es'
      }/${backUrl}`;
    }
  };

  static getParametersFromUrl = () => {
    const queryString = LocationHelper.getQueryString();
    const params = Object();
    const queries = queryString.split('&');
    queries.forEach((indexQuery: string) => {
      const indexPair = indexQuery.split('=');
      const queryKey = decodeURIComponent(indexPair[0]);
      params[queryKey] = decodeURIComponent(
        indexPair.length > 1 ? indexPair[1] : '',
      );
    });
    return params;
  };

  static getQueryString = () => {
    return window.location.search.substring(1);
  };

  static fixRedsysCallbackIframeProblems() {
    if (StorageHelper.isGoneToImpagos()) {
      StorageHelper.removeGoneToImpagos();
      if (window.self !== window.top) {
        window.parent.location.href = window.location.href;
      }
    }
  }
}
/* eslint-enable import/no-cycle */
